export default __webpack_public_path__ + "static/media/padlock.10a6e5e4.svg";